<template>
  <div class="page close-picker">
    <div class="page-content">
      <div class="layoutTop"/>

      <div class="container-fluid">
        <div class="row">
          <div class="col-md-10 offset-md-1">
            <i class="icon fa fa-arrow-left" style="margin-top:25px;margin-bottom:25px" @click="goBack()">
              <span class="ml-1 backLabel" style="font-size:large">{{ $t('common.bck') }}</span>
            </i>
            <div class="panel21 panel-default">
              <div class="panel-heading">
                <h4 class="content-block labelAccordionForm">
                    <img src='../../assets/static/images/icons/paperclip.png' class="formIcon formIconSmall"/>
                    {{ $t('attachments.create_refund') }}
                </h4>
              </div>

              <ul>
                <div class="accordion-item accordionForm">
                  <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                    <div class="item-inner" v-bind:class="colorBottomButton">
                      <div class="form-group row justify-content-start">
                        <div class="item-title createInvoiceBand col-sm-auto">
                          {{ $t('common.formsSubTitle.gnrl') }}
                          <i class="f7-icons formChevron">chevron_right</i>
                        </div>
                      </div>
                    </div>
                  </a>

                  <div class="accordion-item-content hasDatePicker">
                    <div class="row">
                      <form-write-group-label-input isMandatory
                        :inputLabel="createRefund_Object" :placeholderValue="createRefund_Object"
                        v-model="remittanceInformation">
                      </form-write-group-label-input>
                      <form-write-group-label-input isMandatory inputType="date"
                        :inputLabel="$t('attachments.issue_date')" :placeholderValue="$t('common.datepicker_format_date')"
                        v-model="dateOfIssue">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </div>
              </ul>
              <hr/>
              <ul>
                <div class="accordion-item accordionForm">
                  <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                    <div class="item-inner" v-bind:class="colorBottomButton">
                      <div class="form-group row justify-content-start">
                        <div class="item-title createInvoiceBand col-sm-auto">
                          {{ $t('common.formsSubTitle.rcpt') }}
                          <i class="f7-icons formChevron">chevron_right</i>
                        </div>
                      </div>
                    </div>
                  </a>

                  <div class="accordion-item-content">
                    <div class="form-group row">
                      <div class="createInvoicePicker col-sm-4" v-bind:class="colorBottomButton">
                        <a href="#" data-picker=".contactListPicker" class="link open-picker button button-round">
                          {{ $t('common.slct_ctcts') }}
                        </a>
                      </div>
                    </div>
                    <div class="row">
                      <form-write-group-label-input isMandatory
                        :inputLabel="createRefund_FullName" :placeholderValue="createRefund_FullName"
                        v-model="debtorName">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        :inputLabel="createRefund_Address" :placeholderValue="createRefund_Address"
                        v-model="debtorAddress">
                      </form-write-group-label-input>
                    </div>
                    <div class="row">
                      <form-write-group-label-input
                        :inputLabel="createRefund_City" :placeholderValue="createRefund_City"
                        v-model="debtorCodeAddress">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        :inputLabel="createRefund_Zipcode" :placeholderValue="createRefund_Zipcode"
                        v-model="debtorZipCode">
                      </form-write-group-label-input>
                    </div>
                    <div class="row">
                      <form-write-group-label-input
                        :inputLabel="createRefund_Country" :placeholderValue="createRefund_Country"
                        v-model="debtorCountry">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </div>
              </ul>
              <hr/>
              <ul>
                <div class="accordion-item accordionForm">
                  <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                    <div class="item-inner" v-bind:class="colorBottomButton">
                      <div class="form-group row justify-content-start">
                        <div class="item-title createInvoiceBand col-sm-auto">
                          {{ $t('common.formsSubTitle.sndr') }}
                          <i class="f7-icons formChevron">chevron_right</i>
                        </div>
                      </div>
                    </div>
                  </a>

                  <div class="accordion-item-content">
                    <div class="row">
                      <form-write-group-label-input isMandatory
                        :inputLabel="createRefund_Identifier" :placeholderValue="createRefund_Identifier"
                        v-model="creditorIdentifier">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        :inputLabel="createRefund_Registrynumber" :placeholderValue="createRefund_Registrynumber"
                        v-model="rcs">
                      </form-write-group-label-input>
                    </div>
                    <div class="row">
                      <form-write-group-label-input
                        :inputLabel="createRefund_TVAnumber" :placeholderValue="createRefund_TVAnumber"
                        v-model="identifierTVA">
                      </form-write-group-label-input>
                      <form-write-group-label-input isMandatory
                        :inputLabel="createRefund_Address" :placeholderValue="createRefund_Address"
                        v-model="creditorAddress">
                      </form-write-group-label-input>
                    </div>
                    <div class="row">
                      <form-write-group-label-input isMandatory
                        :inputLabel="createRefund_City" :placeholderValue="createRefund_City"
                        v-model="creditorCodeAddress">
                      </form-write-group-label-input>
                      <form-write-group-label-input isMandatory
                        :inputLabel="createRefund_Zipcode" :placeholderValue="createRefund_Zipcode"
                        v-model="creditorZipCode">
                      </form-write-group-label-input>
                    </div>
                    <div class="row">
                      <form-write-group-label-input isMandatory
                        :inputLabel="createRefund_Country" :placeholderValue="createRefund_Country"
                        v-model="creditorCountry">
                      </form-write-group-label-input>
                      <form-write-group-label-input
                        :inputLabel="createRefund_LegalForm" :placeholderValue="createRefund_LegalForm"
                        v-model="legalForm">
                      </form-write-group-label-input>
                    </div>
                    <div class="row">
                      <form-write-group-label-input inputType="number"
                        :inputLabel="$t('common.shr_cptl') + ' (€)'" :placeholderValue="createRefund_amount"
                        v-model="amountOfCapital">
                      </form-write-group-label-input>
                    </div>
                    <div class="form-group row">
                      <div class="col-5 col-sm-2 " v-bind:class="colorBottomButton">
                        <label for="fileLogo" class="inputFileButton attachementCreateInvoiceButtonLength" style="width: 90%;">{{ $t('common.lgo') }}</label>
                      </div>
                      <input type="file" name="fileLogo" id="fileLogo" class="inputfile" @change="uploadFile"/>
                      <div class="col-7 col-sm-10">
                        <input class="form-control" name="filename" :placeholder="createRefund_Choosefile" type="text" v-model="logoName" disabled>
                      </div>
                    </div>
                  </div>
                </div>
              </ul>
              <hr/>
              <ul>
                <div class="accordion-item accordionForm">
                  <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                    <div class="item-inner" v-bind:class="colorBottomButton">
                      <div class="form-group row justify-content-start">
                        <div class="item-title createInvoiceBand col-sm-auto">
                          {{ $t('common.formsSubTitle.rfnd') }}
                          <i class="f7-icons formChevron">chevron_right</i>
                        </div>
                      </div>
                    </div>
                  </a>

                  <div class="accordion-item-content hasDatePicker">
                    <div class="row">
                      <form-write-group-label-input isMandatory inputType="date"
                        :inputLabel="$t('attachments.blng_date')" :placeholderValue="$t('common.datepicker_format_date')"
                        v-model="dateOfSale">
                      </form-write-group-label-input>
                      <form-write-group-label-input isMandatory
                        :inputLabel="createRefund_Refundnumber" :placeholderValue="createRefund_Refundnumber"
                        v-model="identifier">
                      </form-write-group-label-input>
                    </div>
                    <div class="row">
                      <form-write-group-label-input isMandatory inputType="number"
                        :inputLabel="createRefund_amount" :placeholderValue="createRefund_amount"
                        v-model="amount">
                      </form-write-group-label-input>
                      <form-write-group-label-input isMandatory inputType="number"
                        :inputLabel="$t('common.ovrpymnt')" :placeholderValue="$t('common.ovrpymnt')"
                        v-model="overpayment">
                      </form-write-group-label-input>
                    </div>
                    <div class="row" v-if="type === '1'" @click="hideBlock($event)">
                      <form-write-group-label-input isMandatory inputType="number"
                        :inputLabel="$t('common.crrct_amnt')" :placeholderValue="createRefund_Correctamount"
                        v-model="newAmount">
                      </form-write-group-label-input>
                    </div>
                  </div>
                </div>
              </ul>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2 offset-md-9">
            <button round class="milkyBlockBlack button-action firstButtonMarginTop" @click="createPDF('cloud')">
              <i class="icon fa fa-save"></i>
              <span>{{ $t('common.sve') }}</span><!-- Save to MoneyRoad -->
            </button>
          </div>
        </div>
      </div>





        <!-- <f7-button icon-f7="forward_fill" class="blueConfirmationButton" color="white" @click="createInvoice('createPayments')">Create payments</f7-button> -->
      <!-- </f7-list> -->
      <div class="picker-modal contactListPicker">
        <div class="toolbar">
          <div class="toolbar-inner">
            <div class="left"></div>
            <div class="right"><a href="#" class="close-picker" @click="contactListPickerCloseButton">{{ $t('common.close_label') }}</a></div>
          </div>
        </div>
        <div class="picker-modal-inner scrollablePicker">
          <form data-search-list=".contactRecipientList" data-search-in=".item-title" class="searchbar searchbar-init">
            <div class="searchbar-input">
              <input type="search" :placeholder="createRefund_Search"><a href="#" class="searchbar-clear"></a>
            </div><a href="#" class="searchbar-cancel">{{ $t('common.cncl') }}</a>
          </form>
          <div class="list-block contactRecipientList">
            <f7-list contacts class="contactRecipientList">
              <f7-list-group v-for="(group, key) in this.contactSelectionList" :key="key">
                <f7-list-item :title="key" group-title></f7-list-item>
                <li v-for="contact in group" :key="'list-contact-option-' + contact.id" :value="contact.id">
                  <label class="label-radio item-content" @click="contactListPickerCloseButton">
                    <input type="radio" name="countryPickerRadio" :value="contact.id">
                    <div class="item-inner">
                      <div class="item-title">{{ contact.name }}</div>
                    </div>
                  </label>
                </li>
              </f7-list-group>
            </f7-list>
          </div>
        </div>
      </div>
      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
  <!-- </f7-page> -->
</template>

<script>

import { jsPDF as JsPDF } from 'jspdf'
// import {post} from '@/helpers/api'
import {errorMessageAlert} from '@/helpers/alert'
// import pageNavBar from '@/components/common/pageNavBar.vue'
// import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import * as pdfjsLib from 'pdfjs-dist'
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.mjs`
import datePickerMixin from '@/mixins/datePickerMixin'
import {loadPage} from '@/helpers/routing'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'

export default {
  name: 'attachmentsCreateInvoice',
  components: {
    // JsPDF,
    // 'page-nav-bar': pageNavBar,
    // 'bottom-toolbar': bottomToolbar,
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  mixins: [datePickerMixin],
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      type: '2', // 1 facture erronée (non utilisé pour le moment) / 2 : trop-perçu
      object: '',
      overpayment: '',
      amount: '',
      newAmount: '',
      dateOfIssue: '',
      identifier: '',
      dateOfSale: '',
      debtorName: '',
      idDebtorName: '',
      debtorAddress: '',
      debtorCodeAddress: '',
      debtorZipCode: '',
      debtorCountry: '',
      creditorIdentifier: '',
      rcs: '',
      creditorAddress: '',
      creditorCodeAddress: '',
      creditorZipCode: '',
      creditorCountry: '',
      legalForm: '',
      amountOfCapital: 0,
      logoAttachment: '',
      logoName: '',
      remittanceInformation: '',
      identifierTVA: '',
      contactDebtors: [],
      contactSelectionList: [],
      contactSelected: '',
      isSmartphone: false
    }
  },
  created () {
    this.createRefund_CreateRefund = this.$i18n.t('attachments.create_refund')
    this.createRefund_Object = this.$i18n.t('attachments.objct')
    this.createRefund_Selectadate = this.$i18n.t('common.slct_date')
    this.createRefund_FullName = this.$i18n.t('common.fll_nm')
    this.createRefund_Address = this.$i18n.t('common.adrs')
    this.createRefund_City = this.$i18n.t('common.cty')
    this.createRefund_Zipcode = this.$i18n.t('common.zp_code')
    this.createRefund_Country = this.$i18n.t('common.ctry')
    this.createRefund_Identifier = this.$i18n.t('common.sndr_name')
    this.createRefund_Registrynumber = this.$i18n.t('common.rgstr_number')
    this.createRefund_TVAnumber = this.$i18n.t('common.tva_nbr')
    this.createRefund_amount = this.$i18n.t('common.amnt')
    this.createRefund_Choosefile = this.$i18n.t('common.chse_file')
    this.createRefund_Refundnumber = this.$i18n.t('attachments.refnd_nmbr')
    this.createRefund_Correctamount = this.$i18n.t('common.crrct_amnt')
    this.createRefund_Search = this.$i18n.t('common.srch')
    this.createRefund_LegalForm = this.$i18n.t('common.lgl_frm')
    if (this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.isSmartphone = true
    }
    let that = this
    that.contactDebtors = this.$engine.contacts.get()
    var contactList = {}
    for (var j = 0; j < this.$engine.contacts.get().length; j++) {
      var firstLetter = this.$engine.contacts.get(j).label.substr(0, 1).toUpperCase()
      if (!Object.hasOwn(contactList, firstLetter)) {
        contactList[firstLetter] = []
      }
      contactList[firstLetter].push({label: this.$engine.contacts.get(j).label, iban: this.$engine.contacts.get(j).iban, login: this.$engine.contacts.get(j).login, name: this.$engine.contacts.get(j).name, id: this.$engine.contacts.get(j).id})
      contactList[firstLetter].sort()
    }
    this.contactSelectionList = this.orderKeys(contactList)
    this.creditorIdentifier = this.$engine.user.get().name
    this.creditorAddress = this.$engine.user.get().address
    this.creditorCodeAddress = this.$engine.user.get().city
    this.creditorZipCode = this.$engine.user.get().zip_code
    this.creditorCountry = this.$engine.user.get().country
    this.legalForm = this.$engine.user.get().legalForm
    this.amountOfCapital = this.$engine.user.get().amountOfCapital
    this.identifierTVA = this.$engine.user.get().identifierTVA
  },
  mounted () {
    /* TLV 18/12/2019
    * Sur grand écran, les accordéons sont étendus par défaut, tandis qu'ils sont repliés sur mobile
    */
    if (!this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.$$('.accordionForm').addClass('accordion-item-expanded')
      this.$$('.formChevron').transform('rotate(90deg)')
    }
  },
  methods: {
    goBack () {
      loadPage(this, {url: '/attachments/'})
    },
    createPDF (type) {
      let that = this
      if (this.verifyData() === true) {
        this.amount = parseFloat(this.amount).toFixed(2)
        this.percentTVA = parseFloat(this.percentTVA).toFixed(2)
        this.newAmount = parseFloat(this.newAmount).toFixed(2)
        this.overpayment = parseFloat(this.overpayment).toFixed(2)

        var imgData = this.logoAttachment
        var doc = new JsPDF()
        if (this.logoAttachment !== '') {
          doc.addImage(imgData, 'PNG', 12, 15, 24, 24)
        }
        doc.setFontSize(12)
        // doc.setFont('times')
        doc.setFont('helvetica')
        doc.setFont(undefined, 'bold')
        doc.setFont('helvetica')
        doc.text(this.creditorIdentifier, 8, 55)
        doc.setFont(undefined, 'normal')
        doc.setFont('helvetica')
        doc.text(this.creditorAddress, 8, 61)
        doc.text(this.creditorZipCode + ' ' + this.creditorCodeAddress + ' ' + this.creditorCountry, 8, 67)
        doc.setFont(undefined, 'bold')
        doc.setFont('helvetica')
        doc.text(this.debtorName, 130, 30)
        doc.setFont(undefined, 'normal')
        doc.setFont('helvetica')
        doc.text(this.debtorAddress, 130, 36)
        doc.text(this.debtorZipCode + ' ' + this.debtorCodeAddress + ' ' + this.debtorCountry, 130, 42)
        doc.setFont(undefined, 'bold')
        doc.setFont('helvetica')
        doc.text('Date : ' + this.formateDate(this.dateOfIssue), 130, 76)
        doc.setFont(undefined, 'bold')
        doc.setFont('helvetica')
        doc.text('Objet : ' + this.remittanceInformation, 8, 97) // TLV 26/09/2019 : object devient remittanceInformation
        doc.setFont(undefined, 'normal')
        doc.setFont('helvetica')
        doc.text('Madame, Monsieur,', 8, 112)
        doc.setFont('helvetica')
        if (this.type === '1') {
          doc.text('Nous vous avons adressé le ' + this.formateDate(this.dateOfSale) + ', la facture numéro ' + this.identifier + ', d\'un montant de ' + this.amount + ' euros TTC.', 8, 122)
          doc.text('Néanmoins, la facture que nous vous avons transmise comporte une erreur sur le prix facturé.', 8, 132)
          doc.text('Le nouveau montant de cette facture s\'élève désormais à ' + this.newAmount + ' euros TTC. Il semble par conséquent', 8, 137)
          doc.text('que nous ayons perçu de votre part une somme trop importante, à savoir ' + this.overpayment + ' euros en trop.', 8, 142)
          doc.text('Ainsi, nous vous sommes redevables de la somme de ' + this.overpayment + ' euros. C\'est pourquoi nous procédons au', 8, 152)
          doc.text('remboursement du montant correspondant qui vous sera transmis dans les plus brefs délais.', 8, 157)
          doc.text('Nous vous prions de bien vouloir nous excuser pour la gêne occasionnée, et restons à votre disposition', 8, 167)
          doc.text('pour toute information complémentaire qui pourrait vous être nécessaire.', 8, 172)
          doc.text('Veuillez agréer l\'expression de nos respectueuses salutations.', 8, 182)
        } else {
          doc.text('Nous avons bien reçu votre paiement de ' + this.amount + ' euros, de la facture numéro : ' + this.identifier + '.', 8, 122)
          doc.text('Il s\'avère cependant que le montant que vous nous avez transmis est supérieur à celui que vous nous', 8, 127)
          doc.text('deviez. Ainsi, nous vous sommes redevables de la somme de ' + this.overpayment + ' euros.', 8, 132)
          doc.text('Afin que la situation rentre dans l\'ordre, nous procédons au remboursement du montant correspondant', 8, 142)
          doc.text('qui vous sera transmis dans les plus brefs délais.', 8, 147)
          doc.text('Veuillez agréer l\'expression de nos respectueuses salutations.', 8, 157)
        }

        doc.setFont(undefined, 'normal')
        doc.setFontSize(12)
        var endLineOne = this.creditorIdentifier
        if (this.legalForm !== '') {
          endLineOne = endLineOne + ' ' + this.legalForm
        }
        if (this.amountOfCapital !== '') {
          endLineOne = endLineOne + ', société au capital social de ' + this.amountOfCapital + ' euros'
        }
        doc.setFont('helvetica')
        doc.text(endLineOne, 8, 270)
        var endLineTwo = ''
        if (this.rcs !== '') {
          endLineTwo = 'RCS de paris n° ' + this.rcs
        }
        if (this.identifierTVA !== '') {
          if (endLineTwo.length > 0) {
            endLineTwo = endLineTwo + ' - '
          }
          endLineTwo = endLineTwo + 'TVA n° ' + this.identifierTVA
        }
        var pos = 275
        if (endLineTwo.length > 0) {
          doc.setFont('helvetica')
          doc.text(endLineTwo, 8, pos)
          pos = pos + 5
        }
        var addrCred = 'Siège social : ' + this.creditorAddress + ' - ' + this.creditorZipCode + ' ' + this.creditorCodeAddress + ' ' + this.creditorCountry
        doc.setFont('helvetica')
        doc.text(addrCred, 8, pos)
        if (type === 'device') {
          doc.save('Invoice.pdf')
          this.cleanData()
          that.$f7.modal({
            title: that.$t('attachments.attchmnts_svd'),
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            loadPage(that, {url: '/attachments/', force: false, ignoreCache: false})
          }, 2000)
        } else if (type === 'cloud') {
          var file = doc.output('datauristring')
          // Code OCR
          var element = this
          var pdfData = atob(file.split(',')[1])
          var loadingTask = pdfjsLib.getDocument({data: pdfData})
          var textDataPromise = loadingTask.promise.then(function (pdf) {
            var pageNumber = 1
            return pdf.getPage(pageNumber).then(function (page) {
              return page.getTextContent().then(function (text) {
                return text.items.map(function (s) { return s.str }).join('\n')
              })
            })
          }, function (reason) {
            // PDF loading error
            console.error(reason)
          })
          .catch(error => {
            errorMessageAlert(error, that)
          })
          textDataPromise.then(function (textData) {
            that.$engine.attachments
              .uploadWebapp(
                element.identifier,
                1,
                'application/pdf',
                that.$i18n.t('attachments.refnd') + '_' + element.identifier + '.pdf',
                file,
                textData,
                that.debtorName,
                that.debtorEmail,
                that.debtorBankAccount,
                that.remittanceInformation,
                that.amount,
                that.paymentsDate,
                'create',
                '',
                that.idDebtorName
              )
              .then(response => {
                element.status = response.status
                if (response.status === 200) {
                  // element.$f7.alert('', 'Attachment imported')
                  element.cleanData()
                  element.$bus.$emit('refresh-cache-attachments')
                  that.$f7.modal({
                    title: that.$t('attachments.attchmnts_svd'),
                    text: '<span class="preloader"></span>'
                  })
                  setTimeout(function () {
                    that.$f7.closeModal()
                    loadPage(that, {url: '/attachments/', force: false, ignoreCache: false})
                  }, 2000)
                }
              })
              .catch(error => {
                errorMessageAlert(error, element)
              })
          })
          .catch(error => {
            errorMessageAlert(error, that)
          })
          // Code OCR
        } else if (type === 'createPayments') {
          let attachmentObj = {
            fromCloudList: true,
            id: 0,
            name: '',
            data: '',
            amount: 0,
            debtorName: '',
            reference: '',
            executionDate: ''
          }
          var fileCreatePayments = doc.output('datauristring')
          // Code OCR
          var elementCreatePayments = this
          attachmentObj.name = this.$t('attachments.invce') + '_' + elementCreatePayments.identifier + '.pdf'
          attachmentObj.data = fileCreatePayments
          attachmentObj.id = ''
          attachmentObj.amount = this.price
          attachmentObj.debtorName = this.debtorName
          attachmentObj.reference = ''
          attachmentObj.executionDate = this.paymentsDate
          that.$engine.settings.set({preChargedFile: attachmentObj})
          loadPage(this, {url: '/payments/newPayments/'})
          this.cleanData()
        }
        this.$f7.closeModal()
      }
    },
    formateDate (date) {
      var todayTime = new Date(date)
      var month = todayTime.getMonth() + 1
      var day = todayTime.getDate()
      var year = todayTime.getFullYear()
      return this.padStart(day, 2) + '/' + this.padStart(month, 2) + '/' + year
    },
    padStart (number, length) {
      var str = '' + number
      while (str.length < length) {
        str = '0' + str
      }
      return str
    },
    uploadFile (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      this.createImage(files[0])
      this.logoName = files[0].name
    },
    createImage (file) {
      var reader = new FileReader()
      var vm = this
      reader.onload = (e) => {
        vm.logoAttachment = e.target.result
      }
      reader.readAsDataURL(file)
    },
    removeImage: function () {
      this.logoAttachment = ''
    },
    cleanData: function () {
      this.dateOfIssue = ''
      this.identifier = ''
      this.dateOfSale = ''
      this.debtorName = ''
      this.idDebtorName = ''
      this.debtorAddress = ''
      this.debtorCodeAddress = ''
      this.debtorZipCode = ''
      this.debtorCountry = ''
      this.creditorIdentifier = ''
      this.rcs = ''
      this.creditorAddress = ''
      this.creditorCodeAddress = ''
      this.creditorZipCode = ''
      this.creditorCountry = ''
      this.legalForm = ''
      this.amountOfCapital = 0
      this.logoAttachment = ''
      this.logoName = ''
      this.remittanceInformation = ''
      this.price = 0
      this.amount = 0
      this.newAmount = 0
      this.overpayment = 0
      this.type = 2
      this.object = ''
      this.identifierTVA = ''
    },
    verifyData: function () {
      var status = false
      if (this.dateOfIssue === '') {
        this.$f7.alert('', this.$t('errors.invld_dt_of_issue'))
      } else if (this.identifier === '') {
        this.$f7.alert('', this.$t('errors.invld_invc_nmbr'))
      } else if (this.dateOfSale === '') {
        this.$f7.alert('', this.$t('errors.invld_dt_of_sale'))
      } else if (this.debtorName === '') {
        this.$f7.alert('', this.$t('errors.invld_dbtr_nm'))
      } else if (this.creditorIdentifier === '') {
        this.$f7.alert('', this.$t('errors.invld_crdtr_idntfr'))
      } else if (this.creditorAddress === '') {
        this.$f7.alert('', this.$t('errors.invld_crdtr_addrss'))
      } else if (this.creditorCodeAddress === '') {
        this.$f7.alert('', this.$t('errors.invld_crdtr_ct_addrss'))
      } else if (this.creditorZipCode === '') {
        this.$f7.alert('', this.$t('errors.invld_zip_code'))
      } else if (this.creditorCountry === '') {
        this.$f7.alert('', this.$t('errors.invld_cntry'))
      } else if (this.remittanceInformation === '') { // TLV 26/09/2019 : object devient remittanceInformation
        this.$f7.alert('', this.$t('errors.invld_rmttnc_info'))
      } else if (this.amount === 0) {
        this.$f7.alert('', this.$t('errors.invld_amnt'))
      } else if (this.newAmount === '' && this.type === '1') {
        this.$f7.alert('', this.$t('errors.invld_crrct_amnt'))
      } else if (this.overpayment === '') {
        this.$f7.alert('', this.$t('errors.invld_ovrpymnt_amnt'))
      } else {
        status = true
      }
      return status
    },
    orderKeys: function (obj) {
      var keys = Object.keys(obj).sort(function keyOrder (k1, k2) {
        if (k1 < k2) return -1
        else if (k1 > k2) return +1
        else return 0
      })
      var i
      var after = {}
      for (i = 0; i < keys.length; i++) {
        after[keys[i]] = obj[keys[i]]
        delete obj[keys[i]]
      }
      for (i = 0; i < keys.length; i++) {
        obj[keys[i]] = after[keys[i]]
      }
      return obj
    },
    contactListPickerCloseButton () {
      let that = this
      this.contactSelected = this.Dom7('input[name=countryPickerRadio]:checked').val()
      for (let i = 0; i < this.contactDebtors.length; i++) {
        if (that.contactDebtors[i].id.toString() === this.contactSelected) {
          // TLV 25/09/2019 : ajout de l'id du contact sélectionné pour l'envoyer à la modé
          that.idDebtorName = that.contactDebtors[i].id.toString()
          that.debtorName = that.contactDebtors[i].name
          that.debtorEmail = that.contactDebtors[i].login
          that.debtorBankAccount = that.contactDebtors[i].iban
          that.debtorAddress = that.contactDebtors[i].address
          that.debtorCodeAddress = that.contactDebtors[i].city
          that.debtorZipCode = that.contactDebtors[i].zipCode
          that.debtorCountry = that.contactDebtors[i].country
        }
      }
      // TLV 04/12/2019 : Fermeture automatique de la liste après avoir choisi un élément
      this.$f7.closeModal('.contactListPicker.modal-in')
    },
    calendarDateOfIssue () {
      /* eslint-disable no-undef */
      let that = this
      if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
        var options = {
          date: new Date(),
          mode: 'date'
        }
        datePicker.show(options, function (date) {
          let year = date.getFullYear().toString()
          let month = (date.getMonth() + 1).toString().length > 1 ? (date.getMonth() + 1).toString() : '0' + (date.getMonth() + 1).toString()
          let day = date.getDate().toString().length > 1 ? date.getDate().toString() : '0' + date.getDate().toString()
          let dateResult = year + '-' + month + '-' + day
          that.dateOfIssue = dateResult
        })
      }
      /* eslint-enable no-undef */
    },
    paymentsDateOfIssue () {
      if (this.dateOfIssue !== undefined) {
        if (this.dateOfIssue.length > 0) {
          return this.dateOfIssue
        } else {
          return this.$t('common.slct_date')
        }
      } else {
        return this.$t('common.slct_date')
      }
    },
    calendarDateOfSale () {
      /* eslint-disable no-undef */
      let that = this
      if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
        var options = {
          date: new Date(),
          mode: 'date'
        }
        datePicker.show(options, function (date) {
          let year = date.getFullYear().toString()
          let month = (date.getMonth() + 1).toString().length > 1 ? (date.getMonth() + 1).toString() : '0' + (date.getMonth() + 1).toString()
          let day = date.getDate().toString().length > 1 ? date.getDate().toString() : '0' + date.getDate().toString()
          let dateResult = year + '-' + month + '-' + day
          that.dateOfSale = dateResult
        })
      }
      /* eslint-enable no-undef */
    },
    paymentsDateOfSale () {
      if (this.dateOfSale !== undefined) {
        if (this.dateOfSale.length > 0) {
          return this.dateOfSale
        } else {
          return this.$t('common.slct_date')
        }
      } else {
        return this.$t('common.slct_date')
      }
    },
    calendarPaymentsDate () {
      /* eslint-disable no-undef */
      let that = this
      if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
        var options = {
          date: new Date(),
          mode: 'date'
        }
        datePicker.show(options, function (date) {
          let year = date.getFullYear().toString()
          let month = (date.getMonth() + 1).toString().length > 1 ? (date.getMonth() + 1).toString() : '0' + (date.getMonth() + 1).toString()
          let day = date.getDate().toString().length > 1 ? date.getDate().toString() : '0' + date.getDate().toString()
          let dateResult = year + '-' + month + '-' + day
          that.paymentsDate = dateResult
        })
      }
      /* eslint-enable no-undef */
    },
    paymentsExecutionDate () {
      if (this.paymentsDate !== undefined) {
        if (this.paymentsDate.length > 0) {
          return this.paymentsDate
        } else {
          return this.$t('common.slct_date')
        }
      } else {
        return this.$t('common.slct_date')
      }
    },
    /* TLV 18/12/2019
    * Fonction qui fait tourner le chevron lorsqu'un accordéon est déroulé ou enroulé.
    * Cette fonction va chercher dans chacun des parents possibles de l'élément sur lequel l'utilisateur
    * a cliqué (4 éléments parents au maximum sur le code de cette page) la classe "'accordion-item-expanded" pour
    * savoir si le chevron doit être orienté vers le bas ou le haut suite au clic
    */
    rotateChevron ($event) {
      if (this.Dom7($event.target).parent().parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().hasClass('accordion-item-expanded')) {
        this.Dom7($event.target).find('i').transform('rotate(0deg)')
      } else {
        this.Dom7($event.target).find('i').transform('rotate(90deg)')
      }
    }
  }
}
</script>
<style scoped>
.blueText {
  color: #12bcf1;
}
.floating-block-popup {
    width: 50%;
    margin-left: 25%;
}
.floating-button-popup {
  right: 15px;
  bottom: 15px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  z-index: 1500;
  background-color: #12bcf1;
  color: #fff;
  overflow: hidden;
  -webkit-transition-duration: .3s;
  transition-duration: .3s;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.attachementCreateInvoiceButtonLength {
  width: 100%;
}

ul {
  padding-left: 0%;
}
</style>
